import head from 'lodash/head';
import compact from 'lodash/compact';

// Build helper text from multiple sources
export const buildHelperText = (...helpText: Array<string | null>) => {
  const texts = compact(helpText);
  if (texts.length === 0) return '';
  if (texts.length === 1) return head(texts) ?? '';
  return texts.join(' ');
};

export const removeBlankValues = <T extends object>(obj: T): Partial<T> => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key as keyof T];
    if (value != null && value !== '') {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as Partial<T>);
};

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

// Scroll a target into view, given either an element or a selector (the
// first match wins). Deferred a tick so state-driven UI updates (e.g. newly
// rendered validation errors) are in the DOM before querying it.
export const scrollTo = (
  target: string | Element | null,
  options: ScrollIntoViewOptions = { behavior: 'smooth', block: 'center' },
  container: ParentNode = document,
) => {
  setTimeout(() => {
    const element =
      typeof target === 'string' ? container.querySelector(target) : target;
    element?.scrollIntoView(options);
  }, 0);
};
